import {Stack} from "@mui/material";
import React from "react";
import {useTranslation} from "react-i18next";
import {ArrowRightAlt as ArrowRightAltIcon, CheckCircle, Error as ErrorIcon} from "@mui/icons-material";
import ContentBox from "./ContentBox";

interface FirmwareChangedContentType {
    prevFirmwareId?: string;
    prevFirmwareVersion?: string;
    currentFirmwareId?: string;
    currentFirmwareVersion?: string;
    targetFirmwareId?: string;
    targetFirmwareVersion?: string;
}

export interface FirmwareChangedContentProps {
    content: string;
}

export default function FirmwareChangedContent({content}: FirmwareChangedContentProps) {
    const {t} = useTranslation();
    const contentTyped = JSON.parse(content) as FirmwareChangedContentType;
    return (
        <Stack direction="row">
            <ContentBox
                title={
                    contentTyped.currentFirmwareId !== contentTyped.targetFirmwareId
                        ? `${t("deviceFirmwareUpdate_versionMismatch")} (${t("device_targetFirmwareVersion")}: ${
                              contentTyped.targetFirmwareVersion
                          })`
                        : undefined
                }
            >
                {contentTyped.currentFirmwareId !== contentTyped.targetFirmwareId ? (
                    <ErrorIcon color="error" />
                ) : (
                    <CheckCircle color="success" />
                )}
            </ContentBox>
            <Stack
                direction="row"
                title={`${t("generic_firmware")}: ${contentTyped.prevFirmwareVersion || ""} → ${
                    contentTyped.currentFirmwareVersion || ""
                }`}
                sx={{margin: "auto 0"}}
            >
                <ContentBox>{contentTyped.prevFirmwareVersion}</ContentBox>
                <ArrowRightAltIcon fontSize="small" />
                <ContentBox>{contentTyped.currentFirmwareVersion}</ContentBox>
            </Stack>
        </Stack>
    );
}
